import React from "react";

import { Card, CardContent, CardMedia, Grid, Typography } from "@mui/material";

import { BlockStandard } from "components/admin/BlockStandard";
import { SolutionsFrame } from "components/solutions/SolutionsFrame";

export const GreenEnergyCongrats = ({ history }) => {
  const handleClick = () => {
    history.push("/frames/store");
  };

  return (
    <SolutionsFrame
      buttonText="Ir para a Loja Virtual"
      onButtonClick={handleClick}
    >
      <BlockStandard hideDivider>
        <img
          style={{ height: "20vh", objectFit: "contain" }}
          src="/static/img/solutions/trophy.png"
          alt=""
        />
        <Typography variant="h2" align="center">
          Parabéns!
        </Typography>
        <Typography>
          Sua decisão de economizar enquanto evita emissões de carbono
          consumindo energia renovável fará muita diferença!
        </Typography>
        <Typography>
          Poupe mais com dispositivos IoT que garantem que os ar-condicionados
          funcionem somente quando necessário e medidores inteligentes que
          acompanham seu consumo em tempo real te ajudando a evitar o
          desperdício de energia.
        </Typography>
      </BlockStandard>

      <BlockStandard hideDivider>
        <Grid item container direction="row" gap={2}>
          <Card sx={{ flex: 1, flexDirection: "column " }}>
            <CardMedia
              sx={{ flex: 1, height: 200 }}
              image="https://www.enermatch.com/wp-content/uploads/2024/11/foto-principal-smartmeter.jpg"
            />
            <CardContent sx={{ flex: 1 }}>
              <Typography variant="body2">
                Medidor Inteligente Wi-Fi com TCs
              </Typography>
              <Typography>A partir de:</Typography>
              <Typography variant="body2">R$ 149,00</Typography>
            </CardContent>
          </Card>
          <Card sx={{ flex: 1 }}>
            <CardMedia
              sx={{ flex: 1, height: 200 }}
              image="https://www.enermatch.com/wp-content/uploads/2024/11/infra-vermelho-01.jpg"
            />
            <CardContent sx={{ flex: 1 }}>
              <Typography variant="body2">
                Controle Remoto Inteligente Un. Infra
              </Typography>
              <Typography>A partir de:</Typography>
              <Typography variant="body2">R$ 149,00</Typography>
            </CardContent>
          </Card>
        </Grid>
      </BlockStandard>
    </SolutionsFrame>
  );
};
